<template>
  <div class="content">
    <div id="cover" style="background-image: url(/static/img/cover.jpg);">
      <div class="cover">
        <h1>{{$t('newPassword.cover')}}</h1>
      </div>
      <div class="gradientslider"></div>
    </div>
    <div class="container sub-content">
      <input type="password" style="opacity: 0;position: absolute;">
      <div class="page page-sm">
        <div class="c-card c-card--success" v-if="linkSend && !seen">
          <div class="c-card--title">
            <h3>{{$t('newPassword.checkEmail')}}</h3>
          </div>
          <div class="c-card--content">
            <p>{{$t('newPassword.checkEmailText')}}</p>
          </div>
          <div class="c-card--footer"></div>
        </div>
        <div class="c-card">
          <div class="c-card--title">
            <h3>{{$t('newPassword.title')}}</h3>
          </div>
          <div class="c-card--content" v-if="!loading">
            <div class="error" v-if="errors.length > 0">
              <p v-for="(item, index) in errors" :index="index" :key="item+index" :item="item">
                {{$t('reset-password.error.' + item.message)||item.message||item}}
              </p>
            </div>
            <div class="">
              <email-input v-required
                           ref="inputEmail"
                           v-error="emailError"
                           :placeholder="$t('newPassword.placeholder.email')"
                           v-model="email" icon="person"
                           :clean-errors-on-input="true"
                           :use-mail-checker="true"/>
            </div>
            <div class="fields">
              <reset-code-input v-required
                          ref="inputCode"
                          v-error="codeError"
                          :placeholder="$t('newPassword.placeholder.code')"
                          :clean-errors-on-input="true"
                          v-model="code"
                          icon="code"/>
            </div>
            <div class="fields">
              <password-input ref="inputPassword" v-required v-error="passwordError" :placeholder="$t('newPassword.placeholder.newPassword')"
                              v-model="password" icon="code"
                              :use-password-checker="true"
                              :use-password-strength-display="true"
                              :clean-errors-on-input="true"
              />
            </div>
            <div class="fields">
              <password-input ref="inputCheckPassword" v-required v-error="passwordCheckError" :placeholder="$t('newPassword.placeholder.verif')"
                              v-model="passwordCheck" icon="code" :should-equal="password" :clean-errors-on-input="true"/>
            </div>
          </div>
          <div class="c-card--content" v-else>
            <div class="loader">
              <loader />
            </div>
          </div>
          <div class="c-card--footer">
            <button class="card-button" :disabled="hasError" @click="send" v-if="!loading">{{$t('newPassword.button')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TextInput from "../../components/text-input";
  import PasswordInput from "../../components/password-input";
  import EmailInput from "../../components/email-input";
  import {withComputeError} from "../../components/mixins/input-wrapper.mixin";
  import ResetCodeInput from "../../components/reset-code-input";
  import {mapState} from "vuex";
  import parseApiError from "../../helpers/api-error-parser";
  import Loader from '../../components/loader.component'

  export default {
    mixins: [withComputeError],
    name: "set-new-password",
    props: {
      linkSend: {
        type: Boolean,
        default: false
      }
    },
    components: {Loader, ResetCodeInput, EmailInput, PasswordInput, TextInput},
    data() {
      return {
        email: '',
        code: '',
        password: '',
        passwordCheck: '',
        passwordError: false,
        passwordCheckError: false,
        emailError: false,
        codeError: false,
        seen: false
      }
    },
    computed: {
      hasError() {
        return this.emailError
          || this.codeError
          || this.passwordError
          || this.passwordCheckError
      },
      ...mapState({
        errors: s => s.resetPassword.errors ? s.resetPassword.errors.map(parseApiError): [],
        loading: s => s.resetPassword.loading
      })
    },
    mounted() {
      if (this.$route.query.email) {
        this.email = this.$route.query.email
      }
      if (this.$route.query.code) {
        this.code = this.$route.query.code
      }
    },
    methods: {
      async send() {
        this.seen = true;
        this.computeErrors();
        if (this.hasError) {
          return;
        }
        await this.$store.dispatch('resetPassword/send', {
          email: this.email,
          code: this.code,
          password: this.password
        })
        await this.$router.push({name: 'home'})
      }
    }
  }
</script>

<style scoped>
  .fields {
    margin-top: 1rem;
  }

  #cover {
    float: none !important;
    margin-bottom: 30px;
  }
  .loader {
    height: 120px;
  }

  .card-button {
    width: auto;
    height: auto;
    margin: 20px auto 0 auto;
  }

  .c-card--content {
    grid-row-gap: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/client/set-new-password.vue